import { render, staticRenderFns } from "./actuals_perf_help_tbn.vue?vue&type=template&id=0f6bc4f1&scoped=true&"
import script from "./actuals_perf_help_tbn.vue?vue&type=script&lang=js&"
export * from "./actuals_perf_help_tbn.vue?vue&type=script&lang=js&"
import style0 from "./actuals_perf_help_tbn.vue?vue&type=style&index=0&id=0f6bc4f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6bc4f1",
  null
  
)

export default component.exports